import { Reveal } from "./shared";
import { HYPOTHESES } from "../../data";

export default function Hypotheses() {
  return (
    <section id="hypotheses" className="relative bg-[#0f1724]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 py-28 md:py-40">
        {/* Sticky left */}
        <div>
          <div className="lg:sticky lg:top-32">
            <div className="font-mono-data text-[#b88457] text-xs tracking-[0.3em] mb-6 flex items-center gap-4">
              <span className="inline-block w-10 h-px bg-[#b88457]" />
              05 // HYPOTHESES
            </div>
            <h2 className="font-display font-black uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.92]">
              Weighing<br />the<br />explanations
            </h2>
            <p className="mt-8 max-w-md text-zinc-400 leading-relaxed">
              Candidate failure modes are not ranked by a score. Each is held against every
              exhibit in turn, and the explanations that cannot survive contradiction fall away —
              until one remains that accounts for the whole record.
            </p>
            <div className="mt-10 border-l border-[#b88457]/40 pl-5 max-w-md">
              <p className="text-zinc-400 text-sm leading-relaxed">
                Reasoning is qualitative and traceable. Every conclusion links back to the evidence
                and testimony that supports it — nothing is asserted without a source.
              </p>
            </div>
          </div>
        </div>

        {/* Scrolling right */}
        <div className="space-y-6">
          {HYPOTHESES.map((h, i) => (
            <Reveal key={h.id} delay={i * 0.05}>
              <div
                data-testid={`hypothesis-${h.id}`}
                className={`relative border p-7 md:p-9 bg-[#152430] ${
                  h.primary
                    ? "border-[#b88457]/50 shadow-[0_0_50px_rgba(184,132,87,0.1)]"
                    : "border-white/10"
                }`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="flex items-center gap-4">
                    <span
                      className={`font-mono-data text-sm px-2 py-1 ${
                        h.primary ? "bg-[#b88457] text-[#0f1724]" : "border border-white/15 text-zinc-400"
                      }`}
                    >
                      {h.id}
                    </span>
                    <span
                      className={`font-mono-data text-[10px] tracking-[0.2em] ${
                        h.verdict === "REJECTED"
                          ? "text-zinc-600"
                          : h.verdict === "PARTIAL"
                          ? "text-amber-400/80"
                          : "text-[#b88457]"
                      }`}
                    >
                      {h.verdict}
                    </span>
                  </div>
                  {h.primary && (
                    <span className="font-mono-data text-[10px] tracking-[0.2em] text-[#b88457] border border-[#b88457]/40 px-2.5 py-1">
                      LEADING EXPLANATION
                    </span>
                  )}
                </div>
                <h3 className="font-display font-bold text-white text-xl md:text-2xl tracking-tight mb-3">
                  {h.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed">{h.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
